import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_3 = { "data-test": "label" }
const _hoisted_4 = {
  style: {"font-size":"1.2em"},
  "data-test": "value"
}
const _hoisted_5 = ["name", "id", "min", "max", "step", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", { for: _ctx.id }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayValue), 1)
    ]),
    _createElementVNode("input", {
      type: "range",
      name: _ctx.name,
      id: _ctx.id,
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      value: _ctx.value,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('modify', _ctx.name, +$event.target.value)))
    }, null, 40, _hoisted_5)
  ], 8, _hoisted_1))
}